import { render, staticRenderFns } from "./DspActions.vue?vue&type=template&id=68e4d21c"
import script from "./DspActions.vue?vue&type=script&lang=js"
export * from "./DspActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports